module.exports = __webpack_public_path__ + "img/drinktracker.6708f242.svg";